import { render, staticRenderFns } from "./UpsertCategory.vue?vue&type=template&id=d1e42948"
import script from "./UpsertCategory.vue?vue&type=script&lang=js"
export * from "./UpsertCategory.vue?vue&type=script&lang=js"
import style0 from "./UpsertCategory.vue?vue&type=style&index=0&id=d1e42948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports